module.exports = __webpack_public_path__ + "img/broadcast-scene-5.e33b343c.png";